import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function ArrowDownIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M10 4v12m6-6-6 6-6-6"
  }));
}

export { ArrowDownIcon };
//# sourceMappingURL=ArrowDown.mjs.map
